import {useCallback, useMemo, useState} from 'react';
import {DragEndEvent, DragStartEvent, PointerSensor, useSensor, useSensors} from '@dnd-kit/core';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';
import {moveLectureToPosition} from '../../../redux/timetable/timetableActions';
import {computeDropPosition} from './timetableSort';

export function useDragLecture(lecturesByDay: Record<number, TTimetableItem[]>) {
    const [activeId, setActiveId] = useState<number | null>(null);
    const sensors = useSensors(useSensor(PointerSensor, {activationConstraint: {distance: 8}}));

    const activeLecture = useMemo(
        () => activeId ? Object.values(lecturesByDay).flat().find(l => l.ttid === activeId) ?? null : null,
        [activeId, lecturesByDay]
    );

    const handleDragStart = useCallback(({active}: DragStartEvent) => setActiveId(Number(active.id)), []);

    const handleDragEnd = useCallback(({active, over}: DragEndEvent) => {
        setActiveId(null);
        if(!over) return;
        const ttid = Number(active.id);
        const overId = Number(over.id);
        if(ttid === overId) return;

        const position = computeDropPosition(ttid, overId, lecturesByDay);
        if(!position) return;

        moveLectureToPosition(ttid, position.targetTsid, position.targetDayKey, position.order);
    }, [lecturesByDay]);

    return {sensors, activeLecture, handleDragStart, handleDragEnd};
}
